// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import config from '../../config/config';
import { PAGE_SIZE } from '../../constants/dataConstants';

// Define a service using a base URL and expected endpoints
export const myAccountListAPI = createApi({
  reducerPath: 'myAccountListAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ['AccountList'],
  endpoints: (builder) => ({
    getAccountList: builder.query<any, myAccountListArgTypes>({
      query: ({ payload, pageNumber }) => ({
        url: `/am/v2/myabo/view?pageNumber=${pageNumber}&pageSize=${PAGE_SIZE}`,
        method: 'POST',
        data: payload,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLazyGetAccountListQuery } = myAccountListAPI;
